<script setup lang="ts">
import type { ToastType } from '@/composables/baseToast'
import { computed } from 'vue'

const props = defineProps<{
  message: string
  type?: ToastType
}>()

const toastClass = computed(() => {
  switch (props.type) {
    case 'success':
      return 'bg-green-600'
    case 'error':
      return 'bg-red-600'
    default:
      return 'bg-blue-600'
  }
})
</script>

<template>
  <div class="flex items-start gap-3 rounded-lg p-4 text-white shadow-md" :class="toastClass">
    <span v-if="props.type === 'success'">✅</span>
    <span v-else-if="props.type === 'error'">❌</span>
    <span v-else>ℹ️</span>
    <div class="flex-1">
      <p class="font-semibold">{{ message }}</p>
    </div>
  </div>
</template>
